var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgArrowLeftNoborderWhite = function SvgArrowLeftNoborderWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M7.712,4c0.697,0.896,0.572,2.181-0.284,2.927L4.996,9.045H19v1.913H4.996l2.432,2.116 C8.285,13.818,8.409,15.104,7.712,16L1,10L7.712,4z"
  })));
};
export default "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB3aWR0aD0iMjBweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjAgMjAiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDIwIDIwIiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik03LjcxMiw0YzAuNjk3LDAuODk2LDAuNTcyLDIuMTgxLTAuMjg0LDIuOTI3TDQuOTk2LDkuMDQ1SDE5djEuOTEzSDQuOTk2bDIuNDMyLDIuMTE2DQoJQzguMjg1LDEzLjgxOCw4LjQwOSwxNS4xMDQsNy43MTIsMTZMMSwxMEw3LjcxMiw0eiIvPg0KPC9zdmc+DQo=";
export { SvgArrowLeftNoborderWhite as ReactComponent };